exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-document-modal .upload-field.pdf-upload {\n  margin-top: 0; }\n\n.add-document-modal .form-group.pdf-title {\n  margin-bottom: 0; }\n\n.error {\n  margin-top: -18px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/content-editor/content-editor-document-modal/content-editor-document-modal.component.scss
// module id = ../../../../../src/app/shared/components/content-editor/content-editor-document-modal/content-editor-document-modal.component.scss
// module chunks = 12